import { render } from "./Or_selectClient.vue?vue&type=template&id=2fbdf55e&scoped=true&ts=true"
import script from "./Or_selectClient.vue?vue&type=script&lang=ts"
export * from "./Or_selectClient.vue?vue&type=script&lang=ts"

import "./Or_selectClient.vue?vue&type=style&index=0&id=2fbdf55e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbdf55e"]])

export default __exports__